import { useState, useEffect, useContext } from "react";
import "./Header.css";
import api from "../../Services/api";
import { useNavigate } from "react-router-dom";
import avatar from "../../Assets/Images/avatar.png";
import { useKeycloak } from "@react-keycloak/web";
import {
  ArrowDownConvg,
  UserIconConvgImage,
  Belliconnew,
  Settings,
} from "../../Components/IconComponents";
import { LayoutState } from "../../Context/LayoutContext/LayoutContext";
import {
  urmservice,
  userImageUpload,
  mediaFileLink,
  getBankAndBranchLogo,
  getThemeURL,
  getOpenTicketsCount,
  getNotificationsList,
  notificationRead,
  getGrievanceData,
  notificationMarkAllRead,
  getAccidentDetails,
} from "../../Services/EndPoints";
// import { useTranslation } from "react-i18next";
import ThemesPopUp from "../../Components/UiComponents/ThemesPopUp/ThemesPopUp";
import { useSelector } from "react-redux";
import { RoleContext } from "../..";
// import SearchBox from "../../Components/UiComponents/Table/TableComponents/SearchBox/SearchBox";
// import { Button } from "react-bootstrap";
import BscbConverge_Logo from "../../Assets/Icons/pruwhite.png";
// import BscbConverge_Icon from "../../Assets/Icons/bscbConvergeIcon.png";
import BscbConvergeBlueLogo from "../../Assets/Icons/prublue.png";
import headericon from "../../Assets/Icons/headericon.png"
import MenuBurger from "../../Assets/Icons/menu-burger.svg";
import { getData, postDataWithBody } from "../../Services/Services";
import ToastNotification from "./ToastNotification";
// Add Modal import
import { Button, Modal } from "react-bootstrap";

const Header = ({ children }) => {
  // const { i18n } = useTranslation();
  const { collapsed, toggle } = LayoutState();
  const [avtarImg, setAvtarImg] = useState(null);
  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const { profileData } = useSelector((store) => store.data);
  const { roleName } = useContext(RoleContext);
  const [logoFromApi, setLogoFromApi] = useState(null);
  const [bankName, setBankName] = useState("");
  const [userProfile, setUserProfile] = useState(null);
  const [avatarFailed, setAvatarFailed] = useState(false); // photo URL broken → fall back to the default icon
  // Redux profile (getUserProfile) is refreshed after "Edit Photo", so prefer it for the header photo
  const headerPhoto = profileData?.[0]?.attachments_path || userProfile?.attachments_path || null;
  useEffect(() => { setAvatarFailed(false); }, [headerPhoto]); // retry when the photo changes
  const isFleetUser = String(userProfile?.app_type || "").toUpperCase() === "FLEET";
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isLoadingNotifications, setIsLoadingNotifications] = useState(false);
  const [isMarkingAllRead, setIsMarkingAllRead] = useState(false);
  const [accidentDetails, setAccidentDetails] = useState();
  // Add state for notification count
  const [notificationCount, setNotificationCount] = useState(0);

  // ✅ ADD THIS STATE FOR USER ID
  const [currentUserId, setCurrentUserId] = useState(null);

  // const changeLanguage = (lng) => {
  //   i18n.changeLanguage(lng);
  // };

  // In Header component, add this useEffect
  useEffect(() => {
    const handleRefreshNotificationCount = () => {
      fetchNotificationCount();
    };

    window.addEventListener(
      "refreshNotificationCount",
      handleRefreshNotificationCount
    );

    return () => {
      window.removeEventListener(
        "refreshNotificationCount",
        handleRefreshNotificationCount
      );
    };
  }, []);

  useEffect(() => {
    if (keycloak && keycloak.tokenParsed) {
      getUserProfileImage(keycloak.tokenParsed.email);
    }
    getUserProfile();
    // Fetch notification count on component mount
    fetchNotificationCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak]);

  // Cleanup function for object URLs (add this useEffect)
  useEffect(() => {
    return () => {
      if (logoFromApi) {
        URL.revokeObjectURL(logoFromApi);
      }
    };
  }, [logoFromApi]);

  const [bankData, setBankData] = useState(null);

  // Add function to fetch notification count
  const fetchNotificationCount = async () => {
    try {
      const response = await getData(getOpenTicketsCount);
      // Handle your new response structure
      if (response && response.unreadCount !== undefined) {
        setNotificationCount(response.unreadCount);
      }
    } catch (error) {
      console.error("Error fetching notification count:", error);
      setNotificationCount(0);
    }
  };
  console.log(avtarImg, "avtarImg");

  // ✅ ADD THIS CALLBACK FOR WHEN NOTIFICATION IS RECEIVED
  const handleNotificationReceived = () => {
    // Refresh notification count when new notification arrives
    fetchNotificationCount();
  };

  // ✅ ADD MODAL HANDLER FUNCTIONS
  const handleShowNotificationModal = () => {
    setShowNotificationModal(true);
    setIsLoadingNotifications(true);
    // Optionally fetch latest notifications when modal opens
    fetchNotifications();
  };

  const handleCloseNotificationModal = () => {
    setShowNotificationModal(false);
    setIsLoadingNotifications(false);
  };

  // ✅ UPDATED FUNCTION TO HANDLE ACCIDENT DETAILS
  const fetchAccidentDetails = async (vehicleTrackId) => {
    try {
      const response = await getData(getAccidentDetails.replace("ID", vehicleTrackId));
      if (response) {
        setAccidentDetails(response);
        return response; // Return the response for further processing
      }
    } catch (error) {
      console.error("Error fetching accident details:", error);
      throw error; // Re-throw to handle in the calling function
    }
  };

  // In your Header component, update the handleNotificationClick function:

  const handleNotificationClick = async (notification) => {
    try {
      setIsLoadingNotifications(true);

      // Only mark as read if it's currently unread
      if (!notification.isRead) {
        const readResponse = await getData(
          notificationRead.replace("ID", notification.id)
        );
        console.log("Notification marked as read:", readResponse);

        const updatedNotifications = notifications.map((n) =>
          n.id === notification.id ? { ...n, isRead: true } : n
        );
        setNotifications(updatedNotifications);
        await fetchNotificationCount();
      }
      if (notification.notificationType === "GEOFENCE_ALERT") {
        console.log(
          "Geofence alert received, navigating to geofence alerts tab:",
          notification
        );

        setShowNotificationModal(false);

        navigate("/Geofencing/assignfencing", {
          state: {
            activeTab: "alerts",
            vehicleTrackId: notification.vehicleTrackId,
            notificationId: notification.id,
            grievanceId: notification.grievanceId,
          },
        });

        return; // Exit early — don't fall through to accident/grievance logic
      }

      if (notification.notificationType === "ROUTE_ALERT") {
        console.log(
          "Route alert received, navigating to deviation route screen:",
          notification
        );

        setShowNotificationModal(false);

        // Best-effort vehicle number pull from the message text — real data
        // will come from the deviation-route API once it's wired up.
        const vehicleMatch = notification.notificationMessage?.match(/Vehicle\s+(\S+(?:\s\S+)?)\s+halted/i);

        navigate("/RoutePlanning/deviation-route", {
          state: {
            alertRefId: notification.grievanceId,
            notificationType: notification.notificationType,
            title: notification.notificationTitle,
            message: notification.notificationMessage,
            createdOn: notification.createdAt,
            vehicleTrackId: notification.vehicleTrackId,
            notificationId: notification.id,
            vehicleNumber: vehicleMatch?.[1],
          },
        });

        return; // Exit early — don't fall through to accident/grievance logic
      }

      // ✅ CHECK IF NOTIFICATION HAS VEHICLE TRACK ID
      if (notification.vehicleTrackId) {
        console.log(
          "Fetching accident details for vehicleTrackId:",
          notification.vehicleTrackId
        );

        try {
          // Fetch accident details
          const accidentResponse = await fetchAccidentDetails(notification.vehicleTrackId);
          console.log("Accident details fetched:", accidentResponse);

          // ✅ CLOSE MODAL AND NAVIGATE TO ACCIDENT DETAILS PAGE
          setShowNotificationModal(false);

          // Navigate to accident details page with the data
          navigate("/RoutePlanning/AccidentViewer", {
            state: {
              accidentData: accidentResponse,
              vehicleTrackId: notification.vehicleTrackId
            },
          });
        } catch (error) {
          console.error("Error fetching accident details:", error);
          // Optionally show error toast to user
        }
      }
      // ✅ IF NOTIFICATION HAS REPORT ID (GRIEVANCE)
      else if (notification.reportId) {
        // ... existing grievance code ...
      } else {
        console.error("No reportId or vehicleTrackId found in notification:", notification);
      }
    } catch (error) {
      console.error("Error handling notification click:", error);
      setIsLoadingNotifications(false);
    }
  };

  // Add this function to handle marking all as read
  const handleMarkAllAsRead = async () => {
    try {
      setIsMarkingAllRead(true);

      // Get all unread notification IDs
      const unreadNotificationIds = notifications
        .filter(n => !n.isRead)
        .map(n => n.id);

      // If no unread notifications, return early
      if (unreadNotificationIds.length === 0) {
        console.log("No unread notifications to mark");
        return;
      }

      // Prepare payload
      const payload = {
        notificationIds: unreadNotificationIds
      };

      // Call the API
      const response = await postDataWithBody(
        notificationMarkAllRead,
        payload,
        {}
      );

      console.log("All notifications marked as read:", response);

      // Refresh notifications list
      await fetchNotifications();

      // Refresh notification count
      await fetchNotificationCount();

    } catch (error) {
      console.error("Error marking all notifications as read:", error);
      // Optionally show error feedback to user
    } finally {
      setIsMarkingAllRead(false);
    }
  };

  // ✅ ADD THESE HELPER FUNCTIONS FROM GRIEVANCE TABLE
  // Status mapping - same as GrievanceTable
  const getStatusFromId = (statusId) => {
    const statusMap = {
      837: "Open",
      838: "In Progress",
      839: "Hold",
      840: "Resolved",
      841: "Closed",
      842: "Rejected",
      843: "In progress someone",
      844: "Resolved someone",
      845: "Escalated to L2",
      846: "Accept",
      847: "Accepted someone",
    };
    return statusMap[statusId] || "Open";
  };


  // Transform grievanceStatusMapEntities with status text
  const transformGrievanceStatusEntities = (grievanceStatusMapEntities) => {
    if (!grievanceStatusMapEntities || !Array.isArray(grievanceStatusMapEntities)) {
      return [];
    }

    return grievanceStatusMapEntities.map(entity => ({
      ...entity, // Keep all original properties (id, createdBy, grievanceId, createdOn, status)
      statusText: getStatusFromId(entity.status) // Add readable status text
    }));
  };

  // Date formatting - same as GrievanceTable
  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "N/A";

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = String(date.getFullYear()).toString();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const formattedHours = String(hours).padStart(2, "0");

    const formattedTime = `${formattedHours}:${minutes} ${ampm}`;

    return `${dd}-${mm}-${yyyy} ${formattedTime}`;
  };

  // ✅ SIMPLIFIED TRANSFORMATION FUNCTION FOR SINGLE RECORD
  const transformSingleGrievanceData = (grievanceResponse) => {
    // Directly transform the single item without mapping
    if (!grievanceResponse || typeof grievanceResponse !== "object") {
      console.error("Invalid grievance response format:", grievanceResponse);
      return null;
    }

    const transformedGrievanceStatusEntities = transformGrievanceStatusEntities(
      grievanceResponse.grievanceStatusMapEntities
    );

    // Transform the single item to match table structure - exactly same as GrievanceTable
    const transformedData = {
      id: grievanceResponse.grievanceSeqId,
      bank: grievanceResponse.bankName,
      branch: grievanceResponse.branchName,
      bankId: grievanceResponse.bankId,
      branchId: grievanceResponse.branchId,
      channel: "Web",
      type: grievanceResponse.issueTypeName,
      subject: grievanceResponse.subject,
      details: grievanceResponse.description
        ? grievanceResponse.description.replace(/<[^>]*>/g, "") // Strip HTML tags
        : "",
      date: formatDateTime(
        grievanceResponse.ticketDateAndTime || grievanceResponse.created_on
      ),
      criticality: grievanceResponse.priority,
      status: getStatusFromId(grievanceResponse.status),
      handler: grievanceResponse.assignedTeamName,
      userLevels: grievanceResponse.userLevel,
      customerName: grievanceResponse.customerName,
      email: grievanceResponse.email,
      phoneNumber: grievanceResponse.phoneNumber,
      issueTypeSubCatName: grievanceResponse.issueTypeSubCatName,
      resolutionMethod: grievanceResponse.resoultionName,
      mediaList: grievanceResponse.mediaList || [],
      originalData: {
        ...grievanceResponse,
        grievanceStatusMapEntities: transformedGrievanceStatusEntities
      },
      isDisable: grievanceResponse.is_disable,
    };

    return transformedData;
  };

  const createGrievancePayload = (userProfile) => {
    const {
      role_name,
      bank_id,
      id: userId,
      is_admin,
      user_level,
    } = userProfile;

    // SUPER ADMIN role
    if (role_name === "SUPER ADMIN") {
      return {
        admin_role: "SA",
        bank_id: null,
        branch_id: null,
        userId: null,
        userLevel: null,
      };
    }

    // HO role
    if (is_admin === true) {
      return {
        admin_role: "HO",
        bank_id: bank_id || null,
        branch_id: null,
        // userId: userId || null,
        userId: null,
        userLevel: null,
      };
    }

    // Default fallback (shouldn't happen in normal cases)
    return {
      admin_role: "USER",
      bank_id: null,
      branch_id: null,
      userId: userId || null,
      userLevel: user_level || null,
    };
  };

  // ✅ UPDATED FUNCTION TO FETCH NOTIFICATIONS FROM YOUR API
  const fetchNotifications = async () => {
    try {
      setIsLoadingNotifications(true);
      const response = await getData(getNotificationsList);
      // Extract data from your API response structure
      if (response && response.data && Array.isArray(response.data)) {
        setNotifications(response.data);
        // Update notification count with actual count from API
        setNotificationCount(response.count || response.data.length);
      } else {
        setNotifications([]);
        setNotificationCount(0);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      setNotifications([]);
      setNotificationCount(0);
    } finally {
      setIsLoadingNotifications(false); // Always stop loading
    }
  };

  // Add getUserProfile function similar to BankTable
  const getUserProfile = async () => {
    try {
      const profile = await getData(getThemeURL);
      if (profile && profile.length > 0) {
        setUserProfile(profile[0]);
        // ✅ SET USER ID FROM PROFILE
        setCurrentUserId(profile[0].id); // Adjust based on your profile structure
        // After getting profile, fetch logo with proper payload (fleet users don't show a bank)
        if (String(profile[0].app_type || "").toUpperCase() !== "FLEET") {
          fetchLogoAndNameFromApi(profile[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(null);
    }
  };

  // Add createPayload function similar to BankTable
  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.role_name === "HO") {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  const byteArrayToImageUrl = (byteArray) => {
    try {
      // Convert byte array to Uint8Array
      const uint8Array = new Uint8Array(byteArray);

      // Create blob from byte array
      const blob = new Blob([uint8Array], { type: "image/png" });

      // Create object URL
      const imageUrl = URL.createObjectURL(blob);

      return imageUrl;
    } catch (error) {
      console.error("Error converting byte array to image:", error);
      return null;
    }
  };

  // Function to fetch logo from API
  // Function to fetch logo and bank name from API
  const fetchLogoAndNameFromApi = async (profile) => {
    try {
      // Create payload using the same logic as BankTable
      const payload = createPayload(profile);
      const response = await postDataWithBody(
        getBankAndBranchLogo,
        payload,
        {}
      );

      if (Array.isArray(response) && response.length > 0) {
        const bankData = response[0];
        setBankData(bankData);
        // Set bank name if available
        if (bankData.bankName) {
          setBankName(bankData.bankName);
        } else if (bankData.branchName) {
          setBankName(bankData.branchName);
        }

        // Check if image field exists and is an array with data
        if (
          bankData.hasOwnProperty("image") &&
          Array.isArray(bankData.image) &&
          bankData.image.length > 0
        ) {
          const imageUrl = byteArrayToImageUrl(bankData.image);
          setLogoFromApi(imageUrl);
        } else {
          setLogoFromApi(null); // Ensure logo is hidden if image is missing or empty
        }
      }
    } catch (error) {
      console.error("Error fetching logo and bank name from API:", error);
      setLogoFromApi(null); // On error, make sure logo is not shown
    }
  };

  const getUserProfileImage = async (email) => {
    let headers = {
      "content-type": "application/json",
    };
    try {
      const response = await api.getData(
        urmservice + userImageUpload + "/" + email,
        {},
        headers
      );
      setAvtarImg(
        urmservice + mediaFileLink + "/" + response.data.user_image.id
      );
    } catch (e) {
      setAvtarImg(avatar);
    }
  };

  return (
    <div className="header_container">
      {/* ✅ ADD TOAST NOTIFICATION COMPONENT HERE */}
      <ToastNotification
        userId={currentUserId}
        onNotificationReceived={handleNotificationReceived}
      />

      <div className={`top__nav ${collapsed ? " collapsed" : null}`}>
        <div className="top__nav-wrapper">
          <div className={`top-menu ${collapsed ? "collapsed" : "expanded"}`}>
            <div
              className="hamburger-container blue-bg"
              onClick={() => toggle(!collapsed)}
            >
              <img src={MenuBurger} alt="Menu" className="MenuBurger" />
            </div>

            {collapsed ? (
              <div className="logo-container">
                <img
                  src={BscbConvergeBlueLogo}
                  alt="Logo"
                  className="logo-collapsed"
                />
              </div>
            ) : (
              <div className="logo-container blue-bg">
                <img src={BscbConverge_Logo} alt="Logo" className="logo" />
              </div>
            )}
          </div>

          <div className="center-box">{children}</div>

          {/* Fleet users see the product name instead of a bank name */}
          {isFleetUser && (
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <img
                src={headericon}
                alt="Prumobility"
                style={{ height: "46px", width: "auto" }}
              />
              <h3
                style={{
                  fontFamily: '"Georgia", "Times New Roman", Times, serif',
                  fontWeight: 600,
                  fontSize: "18px",
                  color: "#000000",
                  margin: 0,
                  textAlign: "center",
                  lineHeight: "1",
                  maxWidth: "730px",
                }}
              >
                PRUMOBILITY FLEET MANAGEMENT SYSTEM
              </h3>
            </div>
          )}

          {/* Conditionally render logo and bank name - hide for SUPER ADMIN */}
          {userProfile && !isFleetUser && userProfile.role_name !== "SUPER ADMIN" && userProfile.role_name !== "Fleet Management" && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                zIndex: "-99999",
              }}
            >
              {logoFromApi && (
                <img
                  src={logoFromApi}
                  alt="Bank Logo"
                  style={{
                    height: "62px",
                    width: "auto",
                  }}
                />
              )}
              {bankData && (
                <h3
                  style={{
                    fontFamily: '"Georgia", "Times New Roman", Times, serif',
                    fontWeight: 600,
                    fontSize:
                      bankData.banknameFontsize ||
                      bankData.branchNameFontsize ||
                      "18px",
                    color:
                      bankData.banknameColour ||
                      bankData.branchNameColour ||
                      "#000000",
                    marginBottom: "-5px",
                    textAlign: "center",
                    whiteSpace: "pre-line",
                    wordBreak: "break-word",
                    lineHeight: "1",
                    maxWidth: "730px",
                  }}
                >
                  {bankName}
                </h3>
              )}
            </div>
          )}

          <div
            className="top__nav-right"
            style={{ display: "flex", alignItems: "center", gap: "16px" }}
          >
            <ThemesPopUp />
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              {/* Bell Icon with Notification Badge */}
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  cursor: "pointer",
                }}
                onClick={handleShowNotificationModal}
              >
                <Belliconnew />
                {notificationCount > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      borderRadius: "50%",
                      padding: "2px 6px",
                      fontSize: "12px",
                      fontWeight: "bold",
                      minWidth: "18px",
                      height: "18px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px solid white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {notificationCount > 99 ? "99+" : notificationCount}
                  </span>
                )}
              </div>
              <Settings />
            </div>

            <div
              className="top__nav-right cursor-pointer"
              onClick={() => {
                navigate("/userProfile");
              }}
            >
              <div className="profile" style={{ marginRight: "-6px" }}>
                {/* User's uploaded photo (attachments_path) if there is one, otherwise the default icon */}
                {headerPhoto && !avatarFailed ? (
                  <img
                    src={headerPhoto}
                    alt="Profile"
                    onError={() => setAvatarFailed(true)}
                    // same box as the default avatar (31.8 × 32.93, rounded square, -10px) so the header doesn't shift;
                    // "contain" shows the whole image (logos / wide pictures aren't cropped)
                    style={{
                      width: "31.8px", height: "32.93px", minWidth: "31.8px", marginTop: "-10px",
                      borderRadius: 8, objectFit: "contain", background: "#fff", border: "1px solid #e2e8f0",
                      display: "block",
                    }}
                  />
                ) : (
                  <UserIconConvgImage style={{ marginTop: "-10px" }} />
                )}
              </div>
              {profileData && (
                <div className="user-details">
                  <span className="user-name">
                    {keycloak.idTokenParsed && keycloak.idTokenParsed.name
                      ? keycloak.idTokenParsed.name
                      : "NA"}
                  </span>
                  <span className="user-role">{roleName}</span>
                </div>
              )}
              <ArrowDownConvg style={{ marginLeft: "-10px" }} />
            </div>
          </div>
        </div>
      </div>
      {/* Notification Modal */}
      <Modal
        show={showNotificationModal}
        onHide={handleCloseNotificationModal}
        size="lg"
        centered
        dialogClassName="notif-modal-dialog"
      >
        <style>{`
          @keyframes notif-spin { to { transform: rotate(360deg); } }
          @keyframes notif-slide-in { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
          .notif-modal-dialog { max-width: 640px !important; }
          .notif-modal-dialog .modal-content { border: none !important; border-radius: 16px !important; overflow: hidden; max-height: none !important; box-shadow: 0 24px 64px rgba(0,0,0,0.18) !important; }
          .notif-modal-dialog .modal-header { border: none !important; padding: 0 !important; }
          .notif-modal-dialog .modal-body { padding: 0 !important; overflow: visible !important; max-height: none !important; }
          .notif-modal-dialog .modal-footer { border: none !important; }
          .notif-card { animation: notif-slide-in 0.18s ease; }
          .notif-card:hover { background: #f0f9ff !important; border-color: #5eead4 !important; }
          .notif-card.unread:hover { background: #fefce8 !important; }
          .notif-scroll::-webkit-scrollbar { width: 5px; }
          .notif-scroll::-webkit-scrollbar-track { background: #f8fafc; }
          .notif-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 99px; }
        `}</style>

        {/* Modal Header */}
        <Modal.Header style={{ padding: 0, border: 'none' }}>
          <div style={{
            width: '100%',
            background: 'rgb(72, 153, 183)',
            padding: '18px 22px',
            display: 'flex', alignItems: 'center', gap: 12,
          }}>
            <div style={{
              width: 42, height: 42, borderRadius: '50%',
              background: 'rgba(255,255,255,0.15)',
              border: '1.5px solid rgba(255,255,255,0.3)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 20, flexShrink: 0,
            }}>🔔</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 700, fontSize: 17, color: '#fff', lineHeight: 1.2 }}>Notifications</div>
              {!isLoadingNotifications && notifications.length > 0 && (
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.75)', marginTop: 3, display: 'flex', gap: 10 }}>
                  <span>{notifications.length} total</span>
                  {notifications.filter(n => !n.isRead).length > 0 && (
                    <span style={{ color: '#fde68a', fontWeight: 600 }}>
                      ● {notifications.filter(n => !n.isRead).length} unread
                    </span>
                  )}
                </div>
              )}
            </div>
            {/* Custom Close Button */}
            <button
              onClick={handleCloseNotificationModal}
              style={{
                width: 32, height: 32, borderRadius: '50%',
                border: '1.5px solid rgba(255,255,255,0.35)',
                background: 'rgba(255,255,255,0.15)',
                color: '#fff', fontSize: 18, fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: 'pointer', lineHeight: 1, flexShrink: 0,
                transition: 'background 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
            >×</button>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: 0 }}>
          {isLoadingNotifications ? (
            <div style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center',
              justifyContent: 'center', padding: '60px 20px', minHeight: 220,
              background: '#f8fafc',
            }}>
              <div style={{
                width: 38, height: 38,
                border: '3px solid #e2e8f0', borderTop: '3px solid #2a8c99',
                borderRadius: '50%', animation: 'notif-spin 0.8s linear infinite',
                marginBottom: 14,
              }} />
              <p style={{ color: '#94a3b8', margin: 0, fontSize: 14 }}>Loading notifications…</p>
            </div>
          ) : notifications.length > 0 ? (
            <div className="notif-scroll" style={{ maxHeight: 'min(460px, calc(100vh - 240px))', overflowY: 'auto', padding: '12px 16px', background: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {notifications.map((notification, index) => {
                const isUnread = !notification.isRead;
                const formattedDate = notification.createdAt
                  ? new Date(notification.createdAt).toLocaleString('en-IN', {
                      day: '2-digit', month: 'short', year: 'numeric',
                      hour: '2-digit', minute: '2-digit', hour12: true,
                    })
                  : '—';
                return (
                  <div
                    key={notification.id || index}
                    className={`notif-card ${isUnread ? 'unread' : ''}`}
                    onClick={() => handleNotificationClick(notification)}
                    style={{
                      background: isUnread ? '#fffbeb' : '#fff',
                      border: isUnread ? '1px solid #fde68a' : '1px solid #e2e8f0',
                      borderLeft: isUnread ? '4px solid #f59e0b' : '4px solid #e2e8f0',
                      borderRadius: 12,
                      padding: '14px 16px',
                      cursor: 'pointer',
                      transition: 'all 0.15s',
                      position: 'relative',
                    }}
                  >
                    {/* Unread dot */}
                    {isUnread && (
                      <span style={{
                        position: 'absolute', top: 14, right: 14,
                        width: 9, height: 9, borderRadius: '50%',
                        background: '#ef4444',
                        boxShadow: '0 0 0 2px #fee2e2',
                        display: 'inline-block',
                      }} />
                    )}

                    {/* Alert ID */}
                    <div style={{ marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{
                        fontSize: 11, fontWeight: 700, color: '#1a7a73',
                        background: '#f0fdfb', border: '1px solid #99f6e4',
                        borderRadius: 5, padding: '2px 8px',
                        fontFamily: 'monospace', letterSpacing: '0.04em',
                        textTransform: 'uppercase',
                      }}>
                        {notification.grievanceId || '—'}
                      </span>
                      {notification.notificationType && (
                        <span style={{
                          fontSize: 10, fontWeight: 600, color: '#64748b',
                          background: '#f1f5f9', borderRadius: 4, padding: '2px 7px',
                          textTransform: 'uppercase', letterSpacing: '0.05em',
                        }}>
                          {notification.notificationType.replace(/_/g, ' ')}
                        </span>
                      )}
                    </div>

                    {/* Alert Title */}
                    <div style={{
                      fontWeight: 700, fontSize: 14, color: '#1e293b',
                      marginBottom: 5, lineHeight: 1.35,
                      paddingRight: isUnread ? 20 : 0,
                    }}>
                      {notification.notificationTitle || '—'}
                    </div>

                    {/* Description */}
                    <div style={{
                      fontSize: 13, color: '#64748b', lineHeight: 1.5,
                      marginBottom: 10,
                      display: '-webkit-box', WebkitLineClamp: 2,
                      WebkitBoxOrient: 'vertical', overflow: 'hidden',
                    }}>
                      {notification.notificationMessage || '—'}
                    </div>

                    {/* Date & Time */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                      <span style={{ fontSize: 12, color: '#94a3b8' }}>🕐</span>
                      <span style={{
                        fontSize: 11, color: '#94a3b8', fontWeight: 500,
                      }}>
                        {formattedDate}
                      </span>
                      {isUnread && (
                        <span style={{
                          marginLeft: 'auto', fontSize: 10, fontWeight: 700,
                          color: '#b45309', background: '#fef3c7',
                          border: '1px solid #fde68a', borderRadius: 4,
                          padding: '1px 7px',
                        }}>Unread</span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div style={{
              textAlign: 'center', padding: '56px 20px',
              background: '#f8fafc', display: 'flex',
              flexDirection: 'column', alignItems: 'center', gap: 12,
            }}>
              <div style={{ fontSize: 48, opacity: 0.25 }}>🔔</div>
              <div style={{ fontSize: 15, color: '#64748b', fontWeight: 500 }}>No notifications</div>
              <div style={{ fontSize: 13, color: '#94a3b8' }}>You're all caught up!</div>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer style={{
          justifyContent: 'space-between', padding: '14px 20px',
          background: '#fff', borderTop: '1px solid #e2e8f0',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            {!isLoadingNotifications && notifications.length > 0 && (
              <>
                <span style={{
                  width: 8, height: 8, borderRadius: '50%',
                  background: notifications.filter(n => !n.isRead).length > 0 ? '#ef4444' : '#16a34a',
                  display: 'inline-block',
                }} />
                <span style={{ fontSize: 13, color: '#64748b', fontWeight: 500 }}>
                  {notifications.filter(n => !n.isRead).length} unread message{notifications.filter(n => !n.isRead).length !== 1 ? 's' : ''}
                </span>
              </>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {!isLoadingNotifications && notifications.length > 0 && notifications.some(n => !n.isRead) && (
              <button
                onClick={handleMarkAllAsRead}
                disabled={isMarkingAllRead}
                style={{
                  display: 'flex', alignItems: 'center', gap: 6,
                  padding: '8px 18px', borderRadius: 8, border: 'none',
                  background: 'rgb(72, 153, 183)',
                  color: '#fff', fontSize: 13, fontWeight: 600,
                  cursor: isMarkingAllRead ? 'not-allowed' : 'pointer',
                  opacity: isMarkingAllRead ? 0.75 : 1,
                  boxShadow: '0 4px 14px rgba(72,153,183,0.35)',
                  transition: 'opacity 0.15s, transform 0.15s',
                }}
                onMouseEnter={e => { if (!isMarkingAllRead) e.currentTarget.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
              >
                {isMarkingAllRead ? (
                  <>
                    <span style={{ width: 13, height: 13, border: '2px solid rgba(255,255,255,0.4)', borderTop: '2px solid #fff', borderRadius: '50%', animation: 'notif-spin 0.8s linear infinite', display: 'inline-block' }} />
                    Marking…
                  </>
                ) : '✓ Mark All as Read'}
              </button>
            )}
            <button
              onClick={handleCloseNotificationModal}
              style={{
                padding: '8px 18px', borderRadius: 8,
                border: '1.5px solid #e2e8f0', background: '#fff',
                color: '#475569', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Header;